import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import { StudentAuthProvider } from "@/StudentAuthContext";
import { TeacherAuthProvider } from "@/TeacherAuthContext";
import Header from "@/components/Header";
import Home from "@/pages/Home";
import Immersion from "@/pages/Immersion";
import Partnerships from "@/pages/Partnerships";
import PartnershipsList from "@/pages/PartnershipsList";
import Students from "@/pages/Students";
import Teachers from "@/pages/Teachers";
import TeacherDashboard from "@/pages/TeacherDashboard";
import TeacherLessons from "@/pages/TeacherLessons";
import TeacherProfile from "@/pages/TeacherProfile";
import TeacherResources from "@/pages/TeacherResources";
import Classroom from "@/pages/Classroom";
import ClassroomFeedback from "@/pages/ClassroomFeedback";
import StudentRecording from "@/pages/StudentRecording";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import MagicLink from "@/pages/MagicLink";
import Book from "@/pages/Book";
import Cart from "@/pages/Cart";
import StudentLogin from "@/pages/StudentLogin";
import StudentRegister from "@/pages/StudentRegister";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Me from "@/pages/Me";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Contact from "@/pages/Contact";

function ChromeAwareHeader() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/classroom/") && !pathname.endsWith("/feedback")) return null;
  return <Header />;
}

function App() {
  return (
    <LanguageProvider>
      <StudentAuthProvider>
        <TeacherAuthProvider>
          <div className="App">
            <BrowserRouter>
              <ChromeAwareHeader />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/immersion" element={<Immersion />} />
                <Route path="/partnerships" element={<Partnerships />} />
                <Route path="/partnerships/teachers" element={<PartnershipsList kind="teacher" />} />
                <Route path="/partnerships/organizations" element={<PartnershipsList kind="organization" />} />
                <Route path="/students" element={<Students />} />
                <Route path="/students/recording" element={<StudentRecording />} />
                <Route path="/teachers" element={<Teachers />} />
                <Route path="/teachers/forgot" element={<ForgotPassword scope="teacher" />} />
                <Route path="/teachers/dashboard" element={<TeacherDashboard />} />
                <Route path="/teachers/lessons" element={<TeacherLessons />} />
                <Route path="/teachers/profile" element={<TeacherProfile />} />
                <Route path="/teachers/resources" element={<TeacherResources />} />
                <Route path="/classroom/:lessonId" element={<Classroom />} />
                <Route path="/classroom/:lessonId/feedback" element={<ClassroomFeedback />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/c/:passcode" element={<MagicLink />} />
                <Route path="/book" element={<Book />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/login" element={<StudentLogin />} />
                <Route path="/register" element={<StudentRegister />} />
                <Route path="/forgot-password" element={<ForgotPassword scope="student" />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/me" element={<Me />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
              <Toaster
                position="top-center"
                toastOptions={{
                  style: {
                    background: "#1C1C1C",
                    color: "#FAF9F6",
                    border: "1px solid rgba(250, 249, 246, 0.1)",
                    fontSize: "14px",
                    letterSpacing: "0.02em",
                  },
                }}
              />
            </BrowserRouter>
          </div>
        </TeacherAuthProvider>
      </StudentAuthProvider>
    </LanguageProvider>
  );
}

export default App;
